import Vue from 'vue'
import Router from 'vue-router'
import staticRoute from './staticRoute'

Vue.use(Router)

const createRouter = () => new Router({
	scrollBehavior: () => ({
		y: 0
	}),
	mode: 'history',
	base:'/expressIndex',
	routes: staticRoute
})

const router = createRouter()


export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router
